import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export const HeroSection = () => {
  return <section className="relative min-h-[70vh] sm:min-h-[90vh] flex flex-col items-center justify-center bg-navy-900 text-white px-4 sm:px-6 py-12 sm:py-20 overflow-hidden" data-id="element-154">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-155">
        <img src="https://cdn.magicpatterns.com/uploads/4qxk3UeKJWysoCU2WijwMN/mujer_cargando_una_casa.png" alt="Mujer cargando una casa" className="w-full h-full object-cover opacity-40 object-top sm:object-center" data-id="element-156" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/60 via-navy-900/80 to-navy-900" data-id="element-157"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center mt-4 sm:mt-10" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} data-id="element-159">
          <h1 className="font-serif text-3xl sm:text-5xl md:text-6xl lg:text-7xl leading-tight sm:leading-tight text-cream-100 mb-4 sm:mb-8" data-id="element-160">
            Si Vives Dándolo Todo y Sientes que Te Estás Desapareciendo...{' '}
            <br className="hidden sm:block" data-id="element-161" />
            <span className="text-amber-400 italic" data-id="element-162">
              Este Mensaje es Para Ti
            </span>
          </h1>
        </motion.div>
      </div>

      <motion.div className="absolute bottom-10 z-10 text-cream-100/60 flex flex-col items-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} data-id="element-163">
        <span className="text-sm tracking-widest uppercase mb-2" data-id="element-164">
          Sigue leyendo
        </span>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-165">
          <ChevronDown size={24} data-id="element-166" />
        </motion.div>
      </motion.div>
    </section>;
};